export const SceneKeys = {
  BOOT: 'Boot',
  PRELOAD: 'Preload',
  TITLE: 'Title',
  UI: 'UI',
  LOADING: 'Loading',
  PROLOGUE: 'Prologue',
  MEMORY_STAGE: 'MemoryStage',
  BATTLE: 'Battle',
  GREEN_HARBOR: 'GreenHarbor',
  TURTLE_INN: 'TurtleInn',
  CHAPTER_END: 'ChapterEnd',
  SHOWCASE: 'Showcase',
} as const;
export type SceneKey = (typeof SceneKeys)[keyof typeof SceneKeys];
